import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "hide",
    standalone: false
})
export class HiddenPipe implements PipeTransform {
  transform(value: string): any {
    return "*".repeat(value?.length);
  }
}
